import DesCatalogConsentPageViewModel from 'viewmodel/DesCatalogConsentPageViewModel';
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';
import { DesAccConstants } from '../constant/desAccConstants';


/* Class add part to library */
export default class DesCatalogConsentPage extends DesBaseCatalogAcc {

    constructor() {
        super(DesCatalogConsentPageViewModel);
    }
    get setStatus() {
        return this.getAttribute(DesAccConstants.SET_STATUS);
    }

    get catalogId() {
        return this.getAttribute(DesAccConstants.CATALOG_ID);
    }

    get isUserSiemensAdmin() {
        return this.getAttribute(DesAccConstants.IS_USER_SIEMENSADMIN);
    }

    get catalogName() {
        return this.getAttribute(DesAccConstants.CATALOG_NAME);
    }

    get isApproveCommand() {
        return this.getAttribute(DesAccConstants.IS_APPROVE_COMMAND) || '';
    }

    getProps() {
        return {
            catalogspaceid: this.catalogspaceId,
            setstatus: this.setStatus,
            catalogid: this.catalogId,
            isusersiemensadmin: this.isUserSiemensAdmin,
            catalogname:this.catalogName,
            isapprovecommand:this.isApproveCommand,

        };
    }

    static get observedAttributes() {
        return [
            ...DesBaseCatalogAcc.observedAttributes,
            DesAccConstants.SET_STATUS,
            DesAccConstants.IS_USER_SIEMENSADMIN,
            DesAccConstants.CATALOG_ID
        ];
    }

}
if (!window.customElements.get('des-catalog-consent-page')) {
    window.customElements.define('des-catalog-consent-page', DesCatalogConsentPage);
}
